interface AssignmentBadgeProps {
  assignedUserId: string | null;
  assignedUserName: string | null;
  currentUserId: string;
}

export const AssignmentBadge = ({ assignedUserId, assignedUserName, currentUserId }: AssignmentBadgeProps) => {
  const isYou = assignedUserId === currentUserId;
  const isUnassigned = assignedUserId === null;

  let dotClass: string;
  let label: string;
  if (isYou) {
    dotClass = 'bg-emerald-500';
    label = 'You';
  } else if (isUnassigned) {
    dotClass = 'bg-amber-500';
    label = 'Unassigned';
  } else {
    dotClass = 'bg-gray-400 dark:bg-gray-500';
    label = assignedUserName ?? 'Unknown';
  }

  return (
    <span className="inline-flex items-center gap-1.5 text-xs text-gray-600 dark:text-gray-400">
      <span data-testid="assignment-badge-dot" className={`h-2 w-2 rounded-full ${dotClass}`} />
      <span>{label}</span>
    </span>
  );
};
